/**
 * Utility functions to work with times (allow/disable form rendering with respect of the campaign settings)
 * See WYN-7646 for more details.
 */

/**
 * Get the current time which is in the campaign creator's timezone in seconds
 * (how many seconds passed from the 0:00 of the current day)
 * @param {string} timezone The campaign timezone (like "Europe/London").
 * @returns {number} Current UTC time in seconds
 */
const getCurrentCampaignDateTime = (timezone) => {
    const now = new Date();
    // get the hour, minutes and seconds on the campaign timezone
    const hoursTZ = new Intl.DateTimeFormat(undefined, {timeZone: timezone, hour: 'numeric', hour12: false}).format(now);
    const minutesTZ = new Intl.DateTimeFormat(undefined, {timeZone: timezone, minute: 'numeric'}).format(now);
    const secondsTZ = new Intl.DateTimeFormat(undefined, {timeZone: timezone, second: 'numeric'}).format(now);
    let hours = Number.parseInt(hoursTZ, 10);
    if (hours >= 24) {
        hours = hours - 24;
    }
    // Return the seconds from 00:00:00
    return  (hours * 3600) + (Number.parseInt(minutesTZ, 10) * 60) + Number.parseInt(secondsTZ, 10);
};

/**
 * Check whether the time is between the bounds (in the range).
 * All time units here are seconds from 0:00 (e.g. 9:00 -> 32400, e.g 32400 seconds passed from 0:00 to 9:00)
 * @param {*} timeToCheck Time which we are going to check (in seconds, from 0:00 of current day)
 * @param {*} timeFrom Left bound of the range (in seconds)
 * @param {*} timeTo Right bound of the range (in seconds)
 * @returns true/false
 */
const isTimeBetween = (timeToCheck, timeFrom, timeTo) => {
    return (timeFrom < timeTo) ?
        (timeToCheck <= timeTo && timeToCheck >= timeFrom) :
        (timeToCheck >= timeFrom || timeToCheck <= timeTo);
};

export { getCurrentCampaignDateTime, isTimeBetween };